import { z } from "zod";
import { canvasElementBaseSchema } from "./canvas-element";

export const pdfSchemaInternal = z.object({
  fileId: z.union([z.number(), z.string()]).nullish(), // If the file is still being uploaded but presented with local preview, he doesn't have a file id yet
  width: z.number(),
  height: z.number(),
  rotate: z.number().optional().default(0),
  uploadStatus: z.union([z.literal("in-progress"), z.literal("completed")]).nullish(),
  uploadProgress: z.number().nullish(), // upload progress in percentages
  currentPage: z.number().default(1),
  totalPages: z.number().default(1),
  pageToDisplay: z.number().positive().optional(), // Optional property to lock PDF to specific page
  customName: z.string().optional(), // Custom name for this specific PDF element
});

export const pdfSchema = canvasElementBaseSchema.merge(pdfSchemaInternal);

export type Pdf = z.infer<typeof pdfSchema>;
export type PdfInternal = z.infer<typeof pdfSchemaInternal>;
